import React from 'react';
import background from '../images/title_bg.svg';

const Plazma = (props) => {
    return (
        <div id="plazma" className="d-flex justify-content-center align-items-center" style={{ backgroundImage: `url(${background})` }}>
            <h1>{props.title}</h1>
        </div>
    );
}

export default Plazma;